<template>
  <chart
    :width="width"
    :height="height"
    :chart-data="chartData"
    :options="options"
  />
</template>
<script>
import Chart from '@/components/charts/Chart'

export default {
  name: 'MonthlySalesBySellerCategoryChart',
  components: {
    Chart
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    },
    report: {
      type: Array,
      default: null
    },
    precision: { // 小数点第何位まで表示するか決める
      type: Number,
      default: 0
    }
  },
  computed: {
    chartData () {
      const datasets = [
        ...new Set(this.report.map(r => r.data).flat()
          .map(d => d.sellerCategory))
      ].map(sellerCategory => ({
        type: 'bar',
        yAxisID: 'barChart',
        label: sellerCategory,
        data: Array(this.report.length).fill(0)
      }))
      for (let i = 0; i < this.report.length; i++) {
        for (const d of this.report[i].data) {
          const datasetIndex = datasets.findIndex(ds => ds.label === d.sellerCategory)
          if (datasetIndex > -1) {
            datasets[datasetIndex].data[i] = d.sales
          }
        }
      }
      return {
        labels: this.report.map(r => r.month),
        datasets: (datasets.length > 0) ? datasets : [
          {
            type: 'bar',
            yAxisID: 'barChart',
            label: '',
            data: []
          }
        ]
      }
    },
    options () {
      return {
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            mode: 'index',
            position: 'nearest',
            callbacks: {
              label (tooltipItem) {
                if (tooltipItem.raw === 0) {
                  return ''
                }
                const label = tooltipItem.dataset.label
                const value = tooltipItem.formattedValue
                if (label.includes('率')) {
                  return `${label}: ${value}%`
                }
                return `${label}: \xA5${value}`
              }
            }
          },
          title: {
            display: true,
            text: '出品者カテゴリー'
          }
        },
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true
          },
          barChart: {
            stacked: true,
            ticks: {
              callback (value) {
                return `\xA5${value.toLocaleString()}`
              }
            }
          }
        }
      }
    }
  }

}
</script>

<style scoped>
</style>
